import { TPropsWithChildren } from "../types/util";
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { LoadingMessageEnum, MessageTypeEnum, RoleEnum } from "../types/chat";

type TChatContext = {
  isLoadingAvatar: boolean;
  setIsLoadingAvatar: Dispatch<SetStateAction<boolean>>;
  history: THistoryItem[];
  setHistory: Dispatch<SetStateAction<THistoryItem[]>>;
  isLoadingGPT: boolean;
  setIsLoadingGPT: Dispatch<SetStateAction<boolean>>;
  isRecording: boolean;
  setIsRecording: Dispatch<SetStateAction<boolean>>;
  isLoadingStt: boolean;
  setIsLoadingStt: Dispatch<SetStateAction<boolean>>;
  activeQuestion: number | null;
  setActiveQuestion: Dispatch<SetStateAction<number | null>>;
};

export type THistoryItem = {
  role: RoleEnum | keyof typeof RoleEnum;
  message: string;
  messageType: MessageTypeEnum | keyof typeof MessageTypeEnum;
  links?: [string];
};

type TProps = TPropsWithChildren;

const TestHistory: THistoryItem[] = [
  {
    role: "human",
    message: LoadingMessageEnum.stt,
    messageType: MessageTypeEnum.loading,
  },
  {
    role: "human",
    message: "你好",
    messageType: MessageTypeEnum.text,
  },
  {
    role: "ai",
    message: LoadingMessageEnum.video,
    messageType: MessageTypeEnum.loading,
  },
  {
    role: "ai",
    message: "好的，請問有什麼需要我回答的問題嗎？",
    messageType: MessageTypeEnum.text,
  },
  {
    role: "ai",
    message: "f1b7d532-ddd4-4e10-adeb-5a07c70089b8",
    messageType: MessageTypeEnum.video,
  },
];

const ChatContext = createContext<TChatContext>({
  isLoadingAvatar: false,
  setIsLoadingAvatar: () => {},
  history: [],
  setHistory: () => {},
  isLoadingGPT: false,
  setIsLoadingGPT: () => {},
  isRecording: false,
  setIsRecording: () => {},
  isLoadingStt: false,
  setIsLoadingStt: () => {},
  activeQuestion: null,
  setActiveQuestion: () => {},
});

const ChatProvider = (props: TProps) => {
  const [isLoadingAvatar, setIsLoadingAvatar] = useState(false);
  const [history, setHistory] = useState<THistoryItem[]>([]);
  const [isLoadingGPT, setIsLoadingGPT] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isLoadingStt, setIsLoadingStt] = useState(false);
  const [activeQuestion, setActiveQuestion] = useState<number | null>(null);

  return (
    <ChatContext.Provider
      value={{
        isLoadingAvatar,
        setIsLoadingAvatar,
        history,
        setHistory,
        isLoadingStt,
        isLoadingGPT,
        isRecording,
        setIsRecording,
        setIsLoadingStt,
        setIsLoadingGPT,
        activeQuestion,
        setActiveQuestion,
      }}
    >
      {props.children}
    </ChatContext.Provider>
  );
};

const useChatContext = () => useContext(ChatContext);

export { ChatProvider, useChatContext };
